import { BeltSyllabus } from './types';

export const blueBeltRedTag: BeltSyllabus = {
    id: 'blue-red',
    name: 'Blue Belt Red Tag',
    color: '#8b008b',
    theoryUnder13: [],
    theoryOver13: [
        {
            title: 'Theory',
            items: [
                {
                    question: 'What is the meaning of Toi-Gye?',
                    answer: 'Toi-Gye was the pen name of the noted scholar Yi Hwang (16th century), an authority on neo-Confucianism. The 37 movements of the pattern refer to his birthplace on 37 degrees latitude. The diagram represents "scholar".'
                },
                {
                    question: 'Note',
                    answer: 'Note that "Toi-Gye" is pronounced "Tway Gyay"'
                },
                {
                    question: 'How many movements in Toi-Gye?',
                    answer: '37'
                },
                {
                    question: 'What is the diagram of Toi-Gye?',
                    answer: 'Scholar'
                },
                {
                    question: 'What is Stamping Motion?',
                    answer: 'Techniques performed in Stamping Motion (Koo-ru-nun Tongjak) are performed when landing into the stance. The motion is created by landing forcefully with the leading leg and using the side sole to create the stamp. The reason for Stamping Motion is to accentuate the technique being performed.'
                }
            ]
        },
        {
            title: 'Korean Terms',
            items: [
                { question: 'Vertical Stance', answer: 'Soojik Sogi' },
                { question: 'Reverse Footsword', answer: 'Balkal Dung' },
                { question: 'Sliding', answer: 'Mikulgi' },
                { question: 'Upward Punch', answer: 'Ollyo Jirugi' },
                { question: 'Backfist Side Back Strike', answer: 'Dung Joomok Yop Dwi Taerigi' },
                { question: 'Twin Side Elbow Thrust', answer: 'Sang Yop Palkup Tulgi' },
                { question: 'Knifehand Side Downward Strike', answer: 'Sonkal Yop Naeryo Taerigi' },
                { question: 'Double Forearm Low Pushing Block', answer: 'Doo Palmok Najundae Miro Makgi' },
                { question: 'Knee Upward Kick', answer: 'Moorup Ollyo Chagi' },
                { question: 'Flying Back Kick', answer: 'Twimyo Dwit Chagi' }
            ]
        }
    ],
    practical: [
        {
            title: 'Practical Elements',
            items: [
                {
                    question: 'L Stance Twin Forearm Block, Upward Punch',
                    answer: 'Forward X 4'
                },
                {
                    question: 'Slide into Fixed Stance Middle Punch, Vertical Stance Knifehand Downward Strike',
                    answer: 'Forward X 4'
                },
                {
                    question: 'Walking Stance Middle Punch, Grab, Side Piercing Kick, L Stance Knifehand Side Strike',
                    answer: 'Forward X 4'
                },
                {
                    question: 'Front Kick, Turning Kick, Side Piercing Kick (Rear Leg - Consecutive Motion), L Stance Forearm Guarding Block',
                    answer: 'Forward X 4'
                }
            ]
        },
        {
            title: 'Power',
            items: [
                {
                    question: 'Left and Right Leg Side Piercing Kick',
                    answer: '2 Boards'
                },
                {
                    question: 'Left and Right Hand Technique (Student\'s Choice)',
                    answer: '1 Board'
                },
                {
                    question: 'Flying Back Piercing Kick',
                    answer: 'Target / Kick Shield'
                }
            ]
        },
        {
            title: 'Pattern',
            items: [
                {
                    question: 'Toi-Gye',
                    answer: ' '
                }
            ]
        },
        {
            title: 'Self Defence',
            items: [
                {
                    question: 'Choke Hold from Rear (Hands and Arm)',
                    answer: ' '
                },
                {
                    question: 'Situational - Pre-emptive Strike(s)',
                    answer: ' '
                },
                {
                    question: 'Situational - Two Attackers (One Holding)',
                    answer: ' '
                }
            ]
        },
        {
            title: 'Sparring',
            items: [
                {
                    question: 'One-Step Sparring',
                    answer: 'Any Foot / Knee Technique (attacker)'
                },
                {
                    question: 'Three-Step Semi-Free Sparring',
                    answer: 'Both start in L Stance Guarding Block, Different Techniques from Previous'
                },
                {
                    question: 'Free Sparring',
                    answer: 'Progression from Previous Grading'
                },
                {
                    question: '2-v-1 Free Sparring',
                    answer: 'Movement and Blocking'
                }
            ]
        }
    ]
};
